// extracted by mini-css-extract-plugin
var _1 = "AttachServiceRequestsModalAISuggestionsPanelRow-moduleavatar__IZ2gG";
var _2 = "AttachServiceRequestsModalAISuggestionsPanelRow-modulecheckbox__gHj2q AICheckbox-moduleaiCheckbox__Bll6O";
var _3 = "AttachServiceRequestsModalAISuggestionsPanelRow-moduleconfidence__y3hZo";
var _4 = "AttachServiceRequestsModalAISuggestionsPanelRow-modulecontent__QtANR";
var _5 = "AttachServiceRequestsModalAISuggestionsPanelRow-modulereason__DEjG2";
var _6 = "AttachServiceRequestsModalAISuggestionsPanelRow-modulerow__JQjnG";
var _7 = "AttachServiceRequestsModalAISuggestionsPanelRow-moduleselected__xlXc_";
var _8 = "AttachServiceRequestsModalAISuggestionsPanelRow-moduletitle__X0Fh6";
export { _1 as "avatar", _2 as "checkbox", _3 as "confidence", _4 as "content", _5 as "reason", _6 as "row", _7 as "selected", _8 as "title" }
